import { cn } from '@/lib/utils';
import { UsersIcon } from '@heroicons/react/24/outline';
import { useGlobalStore } from '@/stores/store';
import { useNavigate } from '@tanstack/react-router';

export const AgentProfile = () => {
  const { setAgentLogout } = useGlobalStore();
  const agentName = useGlobalStore((state) => state.authStore.agentName);
  const navigate = useNavigate();

  if (!agentName) {
    return null;
  }

  const name = agentName.split(' ')[0];

  const handleAgentLogout = () => {
    navigate({
      to: '.',
      search: (search) => ({ ...search, 'agent-token': undefined }),
    });
    setAgentLogout();
  };
  return (
    <button
      onClick={handleAgentLogout}
      className={cn(
        'cursor-pointer flex gap-1 items-center p-2 pl-3 md:px-5 md:pl-3 md:py-[10px] mt-2 lg:mt-0 lg:p-0',
        {
          hidden: !agentName,
        }
      )}
    >
      <UsersIcon className=" lg:text-white size-5 stroke-2 text-black" />
      <span className="font-nunito700 text-xs text-black ">
        Not {name}? Logout
      </span>
    </button>
  );
};
